export default "__VITE_ASSET__9ZskiCU9__"